import type { AppEnvType } from '../app-env';
import { siteDomain } from '../site';

export type EmailProviderType = 'cloudflare' | 'resend';

export interface IEmailSenderVars {
  fromEmail: string;
  fromName: string;
  replyTo: string;
}

export interface IEmailVars {
  provider: EmailProviderType;
  cloudflare: IEmailSenderVars;
  resend: IEmailSenderVars;
}

const cloudflareSendDomain = `mail.${siteDomain}`;

export const emailVars: Record<AppEnvType, IEmailVars> = {
  local: {
    provider: 'cloudflare',
    cloudflare: {
      fromEmail: `welcome@${cloudflareSendDomain}`,
      fromName: 'Cool Mate (Local)',
      replyTo: `hi+local@${siteDomain}`,
    },
    resend: {
      fromEmail: `local@${siteDomain}`,
      fromName: 'Cool Mate (Local)',
      replyTo: `hi+local@${siteDomain}`,
    },
  },
  dev: {
    provider: 'cloudflare',
    cloudflare: {
      fromEmail: `welcome@${cloudflareSendDomain}`,
      fromName: 'Cool Mate (Dev)',
      replyTo: `hi+dev@${siteDomain}`,
    },
    resend: {
      fromEmail: `dev@${siteDomain}`,
      fromName: 'Cool Mate (Dev)',
      replyTo: `hi+dev@${siteDomain}`,
    },
  },
  stg: {
    provider: 'cloudflare',
    cloudflare: {
      fromEmail: `welcome@${cloudflareSendDomain}`,
      fromName: 'Cool Mate (Staging)',
      replyTo: `hi+stg@${siteDomain}`,
    },
    resend: {
      fromEmail: `stg@${siteDomain}`,
      fromName: 'Cool Mate (Staging)',
      replyTo: `hi+stg@${siteDomain}`,
    },
  },
  prod: {
    provider: 'cloudflare',
    cloudflare: {
      fromEmail: `welcome@${cloudflareSendDomain}`,
      fromName: 'Cool Mate',
      replyTo: `hi@${siteDomain}`,
    },
    resend: {
      fromEmail: `no-reply@${siteDomain}`,
      fromName: 'Cool Mate',
      replyTo: `hi@${siteDomain}`,
    },
  },
};
